<!-- Wallet Management -->
<div class="wallet-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-main">
        <div class="header-icon">
          <i class="fas fa-wallet"></i>
        </div>
        <div class="header-text">
          <h1 class="page-title">Wallet</h1>
          <p class="page-description">Manage your wallet balance and withdrawal history</p>
        </div>
      </div>
      <div class="header-actions">
        <button class="btn btn-outline-secondary btn-sm" (click)="getWalletBalance(); getUnAppWalletBalance(); fetchWithdrawalHistory()">
          <i class="fas fa-sync-alt"></i>
          Refresh
        </button>
        <button class="btn btn-primary" (click)="openWithdrawModal()">
          <i class="fas fa-money-bill-wave"></i>
          Withdraw
        </button>
      </div>
    </div>
  </div>

  <!-- Balance Cards -->
  <div class="row g-4 mb-4">
    <!-- Wallet Balance Card -->
    <div class="col-xl-6 col-lg-6">
      <div class="card">
        <div class="card-body p-4">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex align-items-center gap-3">
              <div class="header-icon" style="background: var(--accent-subtle); color: var(--accent); width: 40px; height: 40px; border-radius: var(--radius-md); display: flex; align-items: center; justify-content: center; font-size: 16px;">
                <i class="fas fa-wallet"></i>
              </div>
              <div>
                <h6 style="font-size: 13px; font-weight: 600; color: var(--text-secondary); margin: 0;">Wallet Balance</h6>
                <p style="font-size: 12px; color: var(--text-tertiary); margin: 2px 0 0;">Available funds for withdrawal</p>
              </div>
            </div>
            <button class="btn btn-outline-secondary btn-sm" (click)="toggleWalletBalanceVisibility()" style="padding: 4px 10px;">
              <i class="fas" [ngClass]="isWalletBalanceHidden ? 'fa-eye' : 'fa-eye-slash'"></i>
            </button>
          </div>

          <div *ngIf="!isLoadingBalance">
            <div *ngIf="!isWalletBalanceHidden; else hiddenWalletBalance"
                 style="font-size: 28px; font-weight: 700; color: var(--text-primary); margin-bottom: 12px;">
              &#8358;{{ balance?.formatted_balance || '0.00' }}
            </div>
            <ng-template #hiddenWalletBalance>
              <div style="font-size: 28px; font-weight: 700; color: var(--text-tertiary); margin-bottom: 12px;">****</div>
            </ng-template>
            <button class="btn btn-primary btn-sm" (click)="openWithdrawModal()">
              <i class="fas fa-money-bill-wave"></i>
              Withdraw Funds
            </button>
          </div>

          <div *ngIf="isLoadingBalance">
            <div class="loading-shimmer" style="height: 32px; width: 180px; border-radius: var(--radius-sm); margin-bottom: 12px;"></div>
            <div class="loading-shimmer" style="height: 14px; width: 100px; border-radius: var(--radius-sm);"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Unapplied Balance Card -->
    <div class="col-xl-6 col-lg-6">
      <div class="card">
        <div class="card-body p-4">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex align-items-center gap-3">
              <div style="background: var(--warning-bg); color: var(--warning-text); width: 40px; height: 40px; border-radius: var(--radius-md); display: flex; align-items: center; justify-content: center; font-size: 16px;">
                <i class="fas fa-hourglass-half"></i>
              </div>
              <div>
                <h6 style="font-size: 13px; font-weight: 600; color: var(--text-secondary); margin: 0;">Unapplied Balance</h6>
                <p style="font-size: 12px; color: var(--text-tertiary); margin: 2px 0 0;">Pending transactions and adjustments</p>
              </div>
            </div>
            <button class="btn btn-outline-secondary btn-sm" (click)="toggleUnappliedBalanceVisibility()" style="padding: 4px 10px;">
              <i class="fas" [ngClass]="isUnappliedBalanceHidden ? 'fa-eye' : 'fa-eye-slash'"></i>
            </button>
          </div>

          <div *ngIf="!isLoadingUnappBalance">
            <div *ngIf="!isUnappliedBalanceHidden; else hiddenUnappliedBalance"
                 style="font-size: 28px; font-weight: 700; color: var(--text-primary); margin-bottom: 12px;">
              &#8358;{{ unAppBalance?.formatted_balance || '0.00' }}
            </div>
            <ng-template #hiddenUnappliedBalance>
              <div style="font-size: 28px; font-weight: 700; color: var(--text-tertiary); margin-bottom: 12px;">****</div>
            </ng-template>
            <span class="badge badge-soft-warning badge-dot">Processing</span>
          </div>

          <div *ngIf="isLoadingUnappBalance">
            <div class="loading-shimmer" style="height: 32px; width: 180px; border-radius: var(--radius-sm); margin-bottom: 12px;"></div>
            <div class="loading-shimmer" style="height: 14px; width: 100px; border-radius: var(--radius-sm);"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters Panel -->
  <div class="filters-panel">
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
      <div class="d-flex align-items-center gap-2">
        <span style="font-size: 13px; font-weight: 600; color: var(--text-secondary);">
          <i class="fas fa-calendar-alt me-2"></i>Date Range
        </span>
      </div>
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <button class="btn btn-sm"
                [class.btn-primary]="selectedDateFilter === 'today'"
                [class.btn-outline-secondary]="selectedDateFilter !== 'today'"
                (click)="setDateRange('today')">Today</button>
        <button class="btn btn-sm"
                [class.btn-primary]="selectedDateFilter === 'week'"
                [class.btn-outline-secondary]="selectedDateFilter !== 'week'"
                (click)="setDateRange('week')">This Week</button>
        <button class="btn btn-sm"
                [class.btn-primary]="selectedDateFilter === 'month'"
                [class.btn-outline-secondary]="selectedDateFilter !== 'month'"
                (click)="setDateRange('month')">This Month</button>
        <button class="btn btn-sm"
                [class.btn-primary]="selectedDateFilter === 'custom'"
                [class.btn-outline-secondary]="selectedDateFilter !== 'custom'"
                (click)="showDatePicker = !showDatePicker; selectedDateFilter = 'custom'">Custom Range</button>
        <button class="btn btn-sm btn-clear-filters"
                *ngIf="selectedDateFilter"
                (click)="clearFilters(); $event.stopPropagation()">
          <i class="fas fa-times me-1"></i>Clear
        </button>
      </div>
    </div>

    <div *ngIf="showDatePicker" style="margin-top: 16px;">
      <div class="row g-3">
        <div class="col-md-5">
          <label class="form-label">Start Date</label>
          <input type="date" class="form-control" #startDate>
        </div>
        <div class="col-md-5">
          <label class="form-label">End Date</label>
          <input type="date" class="form-control" #endDate>
        </div>
        <div class="col-md-2 d-flex align-items-end">
          <button class="btn btn-primary btn-block"
                  (click)="onCustomDateSelect(startDate.value, endDate.value)">
            Apply
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="dateRange.from && dateRange.to" style="margin-top: 10px;">
      <span class="badge badge-soft-info">
        <i class="fas fa-calendar me-1"></i>
        {{formatDisplayDate(dateRange.from)}} - {{formatDisplayDate(dateRange.to)}}
      </span>
    </div>
  </div>

  <!-- Withdrawal History Table -->
  <div class="data-panel">
    <div class="panel-header">
      <div class="panel-title">
        <div class="title-icon">
          <i class="fas fa-history"></i>
        </div>
        <div>
          <div class="title-text">Withdrawal History</div>
          <div class="title-subtitle">Complete record of all withdrawal transactions</div>
        </div>
      </div>
      <div class="panel-info">
        <span class="badge badge-light">{{withdrawalHistory?.length || 0}} records</span>
      </div>
    </div>

    <div class="panel-body">
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount (&#8358;)</th>
              <th>Bank Details</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <!-- Data rows -->
            <tr *ngFor="let transaction of withdrawalHistory" [hidden]="isLoadingHistory">
              <td>
                <div style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{ transaction.created_at | date:'mediumDate' }}</div>
                <div style="font-size: 12px; color: var(--text-tertiary);">{{ transaction.created_at | date:'shortTime' }}</div>
              </td>
              <td>
                <span style="font-size: 13px; font-weight: 600; color: var(--text-primary);">&#8358;{{ transaction.amount | number:'1.2-2' }}</span>
              </td>
              <td>
                <div style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{ transaction.bank_name }}</div>
                <div style="font-size: 12px; color: var(--text-tertiary);">{{ transaction.bank_account_number }}</div>
              </td>
              <td>
                <span class="badge badge-dot"
                      [ngClass]="getStatusClass(transaction.status)">
                  {{ transaction.status | titlecase }}
                </span>
              </td>
            </tr>

            <!-- Loading shimmer rows -->
            <tr *ngFor="let i of [1,2,3,4,5,6,7,8]" [hidden]="!isLoadingHistory">
              <td>
                <div class="loading-shimmer" style="height: 14px; width: 100px; border-radius: var(--radius-sm); margin-bottom: 4px;"></div>
                <div class="loading-shimmer" style="height: 12px; width: 60px; border-radius: var(--radius-sm);"></div>
              </td>
              <td>
                <div class="loading-shimmer" style="height: 14px; width: 80px; border-radius: var(--radius-sm);"></div>
              </td>
              <td>
                <div class="loading-shimmer" style="height: 14px; width: 120px; border-radius: var(--radius-sm); margin-bottom: 4px;"></div>
                <div class="loading-shimmer" style="height: 12px; width: 100px; border-radius: var(--radius-sm);"></div>
              </td>
              <td>
                <div class="loading-shimmer" style="height: 22px; width: 70px; border-radius: 20px;"></div>
              </td>
            </tr>

            <!-- Empty state -->
            <tr *ngIf="withdrawalHistory?.length === 0 && !isLoadingHistory">
              <td colspan="4">
                <div class="empty-state">
                  <div class="empty-icon">
                    <i class="fas fa-history fa-3x"></i>
                  </div>
                  <div class="empty-content">
                    <h5>No Withdrawal History</h5>
                    <p>Your withdrawal transactions will appear here once you make a withdrawal.</p>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="size > pageSize" class="panel-footer">
      <div class="pagination-info">
        Showing page {{page}} of {{ (size / pageSize) | number:'1.0-0' }}
      </div>
      <ngb-pagination
        [collectionSize]="size"
        [(page)]="page"
        [pageSize]="pageSize"
        [maxSize]="5"
        [rotate]="true"
        [ellipses]="false"
        [boundaryLinks]="true"
        (pageChange)="onPageChange($event)">
      </ngb-pagination>
    </div>
  </div>

  <!-- Withdraw Modal -->
  <div class="modal-overlay" *ngIf="showWithdrawModal" (click)="closeWithdrawModal()">
    <div class="modal-container" (click)="$event.stopPropagation()" style="background: var(--bg-surface); border: 1px solid var(--border); border-radius: var(--radius-xl); box-shadow: var(--shadow-lg); max-width: 480px; width: 100%; margin: auto;">

      <div style="padding: 20px 24px; border-bottom: 1px solid var(--border); background: var(--bg-muted); border-radius: var(--radius-xl) var(--radius-xl) 0 0; display: flex; align-items: center; justify-content: space-between;">
        <div class="d-flex align-items-center gap-3">
          <div style="width: 36px; height: 36px; border-radius: var(--radius-md); background: var(--accent-subtle); color: var(--accent); display: flex; align-items: center; justify-content: center; font-size: 15px;">
            <i class="fas fa-money-bill-wave"></i>
          </div>
          <h5 style="font-size: 16px; font-weight: 600; color: var(--text-primary); margin: 0;">Withdraw Funds</h5>
        </div>
        <button class="btn btn-outline-secondary btn-sm" (click)="closeWithdrawModal()" style="padding: 4px 8px;">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div style="padding: 24px;">
        <div class="form-group">
          <label class="form-label">
            <i class="fas fa-university me-1"></i>
            Select Bank Account
          </label>
          <select class="form-select" [(ngModel)]="selectedBank" [disabled]="isLoadingBanks">
            <option value="">Select a bank account</option>
            <option *ngFor="let bank of banks" [value]="bank.id">
              {{bank.account_number}} - {{bank.bank}} ({{bank.account_name}})
            </option>
          </select>
          <div *ngIf="isLoadingBanks" style="margin-top: 6px;">
            <small style="color: var(--text-tertiary);"><i class="fas fa-spinner fa-spin me-1"></i>Loading banks...</small>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">
            <i class="fas fa-dollar-sign me-1"></i>
            Withdrawal Amount
          </label>
          <div class="input-group">
            <span class="input-group-text" style="background: var(--bg-muted); border-color: var(--input-border); color: var(--text-secondary); font-weight: 600;">&#8358;</span>
            <input type="number"
                   class="form-control"
                   [(ngModel)]="withdrawAmount"
                   min="0"
                   [max]="balance?.balance || 0"
                   placeholder="Enter amount"
                   [disabled]="isSubmittingWithdrawal">
          </div>
          <small style="color: var(--text-tertiary); margin-top: 6px; display: block;">
            Available Balance: &#8358;{{balance?.formatted_balance || '0.00'}}
          </small>
        </div>

        <div *ngIf="withdrawAmount > 0 && selectedBank"
             style="background: var(--bg-muted); border-radius: var(--radius-md); padding: 16px; border: 1px solid var(--border-subtle);">
          <h6 style="font-size: 12px; font-weight: 600; color: var(--text-secondary); margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.05em;">
            <i class="fas fa-receipt me-1"></i>Withdrawal Summary
          </h6>
          <div class="d-flex justify-content-between mb-2" style="font-size: 13px; color: var(--text-secondary);">
            <span>Amount:</span>
            <span>&#8358;{{withdrawAmount | number:'1.2-2'}}</span>
          </div>
          <div class="d-flex justify-content-between mb-2" style="font-size: 13px; color: var(--text-secondary);">
            <span>Processing Fee:</span>
            <span>&#8358;0.00</span>
          </div>
          <div style="border-top: 1px solid var(--border); padding-top: 8px; margin-top: 8px;" class="d-flex justify-content-between">
            <span style="font-size: 13px; font-weight: 600; color: var(--text-primary);">Total:</span>
            <span style="font-size: 13px; font-weight: 600; color: var(--text-primary);">&#8358;{{withdrawAmount | number:'1.2-2'}}</span>
          </div>
        </div>
      </div>

      <div style="padding: 16px 24px; border-top: 1px solid var(--border); background: var(--bg-muted); border-radius: 0 0 var(--radius-xl) var(--radius-xl); display: flex; justify-content: flex-end; gap: 10px;">
        <button class="btn btn-outline-secondary"
                (click)="closeWithdrawModal()"
                [disabled]="isSubmittingWithdrawal">
          Cancel
        </button>
        <button class="btn btn-primary"
                (click)="submitWithdrawal()"
                [disabled]="!selectedBank || withdrawAmount <= 0 || isSubmittingWithdrawal">
          <span *ngIf="!isSubmittingWithdrawal">
            <i class="fas fa-paper-plane me-1"></i>
            Confirm Withdrawal
          </span>
          <span *ngIf="isSubmittingWithdrawal">
            <i class="fas fa-spinner fa-spin me-1"></i>
            Processing...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
